var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.roomDataInitComplete
    ? _c(
        "div",
        {
          staticClass: "room-call-component relative",
          attrs: { "data-grm-comp": "RoomCall" },
        },
        [
          _c(
            "div",
            { staticClass: "room-call" },
            [
              _vm.isMixingCallType
                ? _c("RoomCallMixing", {
                    attrs: {
                      secondVideo: _vm.secondVideo,
                      videoOnly: _vm.videoOnly,
                    },
                  })
                : _vm._e(),
              _vm.isCamStudy
                ? _c("RoomCallCamStudyP2P", {
                    attrs: { videoOnly: _vm.videoOnly, pip: _vm.pip },
                  })
                : _vm.isP2PCallType
                ? _c("RoomCallP2P", {
                    attrs: { videoOnly: _vm.videoOnly, pip: _vm.pip },
                  })
                : _vm._e(),
              _vm.isMixerSFUCallType
                ? _c("RoomCallP2P", {
                    attrs: { videoOnly: _vm.videoOnly, pip: _vm.pip },
                  })
                : _vm._e(),
              _vm.pip
                ? [_vm.isMixingCallType ? _c("RoomCallNewWindow") : _vm._e()]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "room-call-other" },
            [
              _c("RoomCallSpeechText", {
                attrs: { stt: _vm.stt, translation: _vm.translation },
              }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }